import React from "react";

const OurMission = () => {
  return (
    <div className="flex flex-col-reverse lg:flex-row items-center w-[85%] lg:::w-[80%] mx-auto my-20">
      <div className="lg:w-[50%] lg:pl-8 mt-10 lg:mt-0">
        <p className="font-popinsMedium text-[#458CB4] text-base">
          M &nbsp;&nbsp;o &nbsp;&nbsp;t &nbsp;&nbsp;o
        </p>
        <h3 className="text-btnColor font-popinsBold text-5xl xl:text-6xl pt-3">Our Mission</h3>
        <p className="font-popinsRegular text-sm lg:text-base pt-8 text-textColor w-[90%]">
          Our mission is to empower investors, developers, and managers by delivering high-performance small bay industrial solutions. We combine market intelligence, design efficiency, and strategic insight to make owning and operating flex space simple, scalable, and successful.
        </p>
      </div>
      <div className="w-full lg:w-[50%]">
        <img src="/assets/whyflex/our-mission.png" alt="" className="size-full object-cover rounded-lg h-[500px]"/>
      </div>
    </div>
  );
};

export default OurMission;
